interface handleNavItemClickParams {
  query: string
  id?: string
  onQueryChanged: (query: string) => void
  sendAnalyticsEvent: (category: string, action: string, label?: Record<string, unknown>) => void
}

/// Handles the click on a navigation item, sending an analytics event and updating the query if it's a soft navigation.
export function getHandlerNavItemClick({query, onQueryChanged, sendAnalyticsEvent, id}: handleNavItemClickParams) {
  const tags = id ? {id} : {shortcut: true}

  return (event: React.MouseEvent) => {
    sendAnalyticsEvent('repos-list.sidebar', 'SIDEBAR_PICKER', tags)
    if (canSoftNavigate(event)) {
      onQueryChanged(query)
      event.preventDefault()
    }
  }
}

/// Detects whether the click is handled on a new window or tab, thus we should ignore it on this instance.
function canSoftNavigate(event: React.MouseEvent) {
  // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic -- Handle locally unless user is opening on a new tab
  return !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0
}

/// Returns the class name for the icon color based on the provided color string.
export function getIconColorClassName(color: string | undefined) {
  const key = color?.toLowerCase() as IconColor
  return colorMap[key] || 'color-fg-muted'
}

const colorMap = {
  ['gray']: 'color-fg-muted',
  ['blue']: 'color-fg-accent',
  ['green']: 'color-fg-success',
  ['orange']: 'color-fg-severe',
  ['red']: 'color-fg-danger',
  ['pink']: 'color-fg-sponsors',
  ['purple']: 'color-fg-done',
} as const

export type IconColor = keyof typeof colorMap
